import * as React from "react";
import { forwardRef } from "react";
const SvgIcShare24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11 3.41414L6.70712 7.70702L5.29291 6.29281L11.2933 0.292419L12.7076 0.292465L18.7072 6.29286L17.2929 7.70698L13 3.41356L13 18H11L11 3.41414Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M3 24L2 23V12L3 11H9V13H4L4 22L20 22V13H15V11H21L22 12V23L21 24L3 24Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcShare24);
export { ForwardRef as ReactComponent };
